import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * OfflineBanner Component
 * 
 * Shows banner when user is offline.
 * Uses online/offline events to detect connection status.
 *
 * @returns {JSX.Element | null} Offline banner or null
 */
export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    // Handle online event
    const handleOnline = () => setIsOffline(false);
    
    // Handle offline event
    const handleOffline = () => setIsOffline(true);

    // Set initial state
    setIsOffline(!navigator.onLine);

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-yellow-900 px-4 py-2 text-center text-sm font-medium animate-slide-down">
      <div className="flex items-center justify-center gap-2">
        <WifiOff className="h-4 w-4" />
        <span>ინტერნეტ კავშირი არ არის. ზოგიერთი ფუნქცია შეიძლება არ მუშაობდეს.</span>
      </div>
    </div>
  );
}
